export default __webpack_public_path__ + "static/media/049-rhinoceros.88851c79.svg";